package com.binayshaw7777.myportfolio

import androidx.compose.runtime.*
import com.binayshaw7777.myportfolio.components.sections.FullScreenLoading
import com.binayshaw7777.myportfolio.components.widgets.*
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.vh
import kotlin.time.Duration.Companion.seconds

private const val COLOR_MODE_KEY = "myportfolio:colorMode"

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = localStorage.getItem(COLOR_MODE_KEY)?.let { ColorMode.valueOf(it) } ?: ColorMode.DARK
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    val cursorModeState = remember { mutableStateOf<CursorMode>(CursorMode.Normal) }

    CompositionLocalProvider(LocalCursorMode provides cursorModeState) {
        SilkApp {
            val colorMode = ColorMode.current
            LaunchedEffect(colorMode) {
                localStorage.setItem(COLOR_MODE_KEY, colorMode.name)
            }

            Surface(
                SmoothColorStyle.toModifier()
                    .minHeight(100.vh)
                    .scrollBehavior(ScrollBehavior.Smooth)
            ) {
                Cursor()
                FullScreenLoading(
                    delay = 0.5.seconds,
                    isLight = ColorMode.current == ColorMode.LIGHT,
                    content = content
                )
            }
        }
    }
}